import React from "react";
import { Button } from "@/components/ui/button";
import { Video, Phone } from "lucide-react";
import { useCall } from "@/context/CallContext";

// Only renders when the two users are friends (server also enforces).
export default function CallButton({ user, canCall, variant = "icon" }) {
  const { startCall, status } = useCall();
  if (!canCall) return null;

  if (variant === "full") {
    return (
      <div className="flex gap-2">
        <Button
          onClick={() => startCall(user, { video: true })}
          disabled={status !== "idle"}
          data-testid="btn-start-video-call"
          className="gap-2 rounded-full bg-pink-500 font-semibold text-white hover:bg-pink-600"
        >
          <Video className="h-4 w-4" /> Video
        </Button>
        <Button
          onClick={() => startCall(user, { video: false })}
          disabled={status !== "idle"}
          data-testid="btn-start-voice-call"
          variant="outline"
          className="gap-2 rounded-full font-semibold"
        >
          <Phone className="h-4 w-4" /> Voice
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={() => startCall(user, { video: false })}
        disabled={status !== "idle"}
        data-testid="btn-start-voice-call"
        title="Voice call"
        className="flex h-11 w-11 items-center justify-center rounded-full text-slate-500 hover:bg-pink-50 hover:text-pink-500 disabled:opacity-40"
      >
        <Phone className="h-[21px] w-[21px]" />
      </button>
      <button
        onClick={() => startCall(user, { video: true })}
        disabled={status !== "idle"}
        data-testid="btn-start-video-call"
        title="Video call"
        className="flex h-11 w-11 items-center justify-center rounded-full text-slate-500 hover:bg-pink-50 hover:text-pink-500 disabled:opacity-40"
      >
        <Video className="h-[21px] w-[21px]" />
      </button>
    </div>
  );
}
